export const FILA_ESCLARECIMENTO = 'ESCLARECIMENTO' as const;

export const FILA_ESCLARECIMENTO_LABEL = 'Esclarecimento';

const TERMOS_ESCLARECIMENTO = ['ESCLARECIMENTO', 'EMBARGO'];

export function ehFilaEsclarecimento(tipoPrazo: string): boolean {
  const alvo = tipoPrazo
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
  return TERMOS_ESCLARECIMENTO.some((termo) => alvo.includes(termo));
}
